import axios from "axios";
import { buildAuthHeaders } from "../buildAuthHeaders";
import { rootUrl } from "../rootUrl";

export type ClientAnalyticsAmount = {
  date: string;
  amount: number;
};

export type ClientAnalyticsContact = {
  date: string;
  count: number;
};

export type ClientAnalyticsCampaign = {
  id: string;
  name: string;
  shortUrl?: string;
  createdAt: string;
};

export type KPIs = {
  totalRaised: number;
  totalDonors: number;
  averageDonation: number;
  conversionRate: number;
  matchingGifts: number;
};

export type DonationBreakdown = {
  oneTime: number;
  recurring: number;
  anonymous: number;
  named: number;
  byTier: {
    tier: string;
    count: number;
    amount: number;
  }[];
};

export type PaymentStatus = {
  completed: number;
  pending: number;
  failed: number;
};

export type Fees = {
  total: number;
  net: number;
};

export type TopDonor = {
  name: string;
  amount: number;
  type: string;
  email: string | null;
  phone: string | null;
};

export type CampaignProgress = {
  goal: number;
  raised: number;
  percentage: number;
  daysRemaining: number | null;
};

export type GetClientAnalyticsResponse = {
  amounts: ClientAnalyticsAmount[];
  campaigns: ClientAnalyticsCampaign[];
  kpis: KPIs;
  donationBreakdown: DonationBreakdown;
  paymentStatus: PaymentStatus;
  fees: Fees;
  topDonors: TopDonor[];
  campaignProgress: CampaignProgress | null;
};

const endpoint = `/client/analytics`;

export const getClientAnalytics = async (
  accessToken: string,
  campaignId?: string,
  timeFrame?: "day" | "month" | "year"
): Promise<GetClientAnalyticsResponse> => {
  const params = new URLSearchParams();
  if (campaignId) params.append("campaignId", campaignId);
  if (timeFrame) params.append("timeFrame", timeFrame);

  const { data } = await axios.get<GetClientAnalyticsResponse>(
    `${rootUrl}${endpoint}${params.toString() ? `?${params.toString()}` : ""}`,
    buildAuthHeaders(accessToken)
  );
  return data;
};
